// Initialised in sentry.html
const Sentry = window.Sentry

export interface SentryUser {
    tenant?: string // Will be set as tag, not user field
    username?: string
    id?: string | number // User ID
    email?: string
    ip_address?: string
}

/**
 * Set user details for Sentry errors
 * @param userDetails
 */
export const setSentryUser = (userDetails: SentryUser) => {
    if (Sentry && Sentry.isInitialized()) {
        Sentry.setTag('tenant', userDetails.tenant ?? 'Unknown')

        const userData: Record<string, string> = {}

        if (userDetails.id != null) {
            userData.id = String(userDetails.id)
        }
        if (userDetails.username) {
            userData.username = userDetails.username
        }
        if (userDetails.email) {
            userData.email = userDetails.email
        }
        if (userDetails.ip_address) {
            userData.ip_address = userDetails.ip_address
        }

        Sentry.setUser(userData)
    }
}
